import React, { useEffect, useRef, useState } from 'react';
import { Search } from 'lucide-react';

function optionText(node) {
  if (typeof node === 'string' || typeof node === 'number') return String(node);
  return React.Children.toArray(node?.props?.children).map(optionText).join(' ');
}

export default function SearchableFilterList({ label, children }) {
  const [query, setQuery] = useState('');
  const search = useRef(null);
  useEffect(() => {
    search.current?.focus({ preventScroll: true });
  }, []);
  const options = React.Children.toArray(children).filter(option =>
    optionText(option).toLowerCase().includes(query.trim().toLowerCase()));
  return <>
    <label className="wh-menu-search"><Search size={13} /><input ref={search} type="search" autoFocus
      aria-label={`Search ${label}`} placeholder={`Search ${label}...`}
      value={query} onChange={event => setQuery(event.target.value)} /></label>
    <div className="wh-menu-list">{options.length ? options : <p className="wh-menu-empty">No matching {label}.</p>}</div>
  </>;
}
